<template>
  <div class="common-alarm-bg">
    <div class="common-alarm-div" ref="lootAlarm">
      <el-form
        :model="dataInfo"
        ref="form"
        :rules="dataInfoRules"
        label-width="80px"
      >
        <table class="alarm-table">
          <colgroup>
            <col style="width: 5%" />
            <col style="width: 30%" />
            <col style="width: 65%" />
          </colgroup>
          <tr>
            <td colspan="3">
              <el-tag type="warning"
                ><i class="el-icon-warning"></i
                >&nbsp;&nbsp;&nbsp;车辆若安装紧急报警按钮，车辆发生紧急状况时司机按下按钮，终端上报劫警报警。报警状态终端无法取消，需要平台下发解除报警指令。如果不启用报警，终端上发“劫警”状态，平台默认下发解除指令。
              </el-tag>
            </td>
          </tr>
          <tr>
            <td>
              <p>是否启用</p>
            </td>
            <td>
              <el-form-item>
                <el-radio-group
                  v-model="dataInfo.alarmCommonAlarmSet.isApply"
                  @change="isApplyChange"
                >
                  <el-radio :label="radioLabel1">是</el-radio>
                  <el-radio :label="radioLabel0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </td>
            <td>
              <p>设置启用为“否”，该项报警设置暂时无效，直到重新启用。</p>
            </td>
          </tr>
          <tr>
            <td>
              <p>适用范围</p>
            </td>
            <td>
              <el-form-item>
                <el-radio-group
                  v-model="dataInfo.alarmCommonAlarmSet.isOverAll"
                  :disabled="alarmSetId == 0 ? false : true"
                >
                  <el-radio :label="radioLabel1">全局设置</el-radio>
                  <el-radio :label="radioLabel0">自定义车辆</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="alarmSetId == 0">
                <e6Select
                  :dataList="vehicleTreeList"
                  :filterable="true"
                  slotTemplate="tree"
                  :issingleleaf="true"
                  multiple
                  ref="e6select"
                  :disabled="
                    dataInfo.alarmCommonAlarmSet.isOverAll == 1 ? true : false
                  "
                  :placeholder="'请选择车辆'"
                >
                </e6Select>
              </el-form-item>
              <el-form-item v-if="alarmSetId != 0">
                <el-input
                  v-model="dataInfo.vehicleNo"
                  size="small"
                  class="alarm-form-input"
                  :disabled="true"
                />
              </el-form-item>
            </td>
            <td>
              <p>
                对指定车辆自定义设置，选择的车辆按照所设置参数进行报警业务判断。若车辆某项报警进行了自定义设置，全局设置参数针对此车不起作用。
              </p>
            </td>
          </tr>
          <tr>
            <td colspan="3">
              <el-button type="text" @click="switchSetting">
                <i
                  :class="[
                    advancedSettingShow
                      ? 'el-icon-arrow-up'
                      : 'el-icon-arrow-down'
                  ]"
                ></i
                >{{ switchSettingBtnText }}
              </el-button>
            </td>
          </tr>
        </table>

        <table v-show="advancedSettingShow" class="alarm-table">
          <colgroup>
            <col style="width: 5%" />
            <col style="width: 30%" />
            <col style="width: 65%" />
          </colgroup>
          <tr>
            <td>
              <p>平台显示</p>
            </td>
            <td>
              <el-form-item>
                <el-radio-group
                  v-model="dataInfo.alarmCommonAlarmSet.isPlateformShow"
                  :disabled="disabledByApply"
                >
                  <el-radio :label="radioLabel1">是</el-radio>
                  <el-radio :label="radioLabel0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </td>
            <td>
              <p>
                设置平台显示为“否”，报警处理及报警报表中记录报警信息，但是报警提示框与车辆定位监控不显示发生的报警信息。
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>警音提醒</p>
            </td>
            <td>
              <el-form-item>
                <el-radio-group
                  v-model="dataInfo.alarmCommonAlarmSet.isAlarmSound"
                  :disabled="disabledByApply"
                >
                  <el-radio :label="radioLabel1">是</el-radio>
                  <el-radio :label="radioLabel0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </td>
            <td>
              <p>
                设置警音提醒显示为“是”，当发生报警的时候，平台会有警音提醒。
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>闪拍</p>
            </td>
            <td>
              <el-form-item>
                <el-radio-group
                  v-model="dataInfo.alarmCommonAlarmSet.isPhoto"
                  :disabled="disabledByApply"
                >
                  <el-radio :label="radioLabel0">关闭</el-radio>
                  <el-radio :label="radioLabel1">开启-拍照</el-radio>
                  <el-radio :label="radioLabel2">开启-10s短视频</el-radio>
                </el-radio-group>
              </el-form-item>
            </td>
            <td>
              <p>
                若选择开启，发生报警时，可抓拍照片或录制10s短视频（需安装摄像头）。
              </p>
            </td>
          </tr>
        </table>
      </el-form>
    </div>
    <div class="text-c mt30 common-alarm-btndiv">
      <el-button type="primary" @click="addData()" :loading="loadingState"
        >保存</el-button
      >
      <el-button @click="cancelSubmit()">取消</el-button>
    </div>
  </div>
</template>

<script>
import e6Select from "e6select";
import {
  FetchSaveLootAlarmSet,
  FetchFindLootAlarmById,
  FetchUpdateLootAlarmSet
} from "@/api/alarmSet/commonAlarmSet";
import { FetchVehicleTree } from "@/api/base/vehicle";

export default {
  name: "lootAlarm",
  components: { e6Select },
  props: ["alarmSetId"],
  data() {
    return {
      loadingState: false,
      vehicleTreeList: [],
      advancedSettingShow: false,
      switchSettingBtnText: "打开高级设置",
      disabledByApply: false,
      dataInfo: {
        alarmCommonAlarmSet: {
          isOverAll: 1,
          isApply: 1,
          isPlateformShow: 0,
          isAlarmSound: 0,
          isPhoto: 0
        }
      },
      dataInfoRules: {}
    };
  },
  methods: {
    //初始化车辆树
    initVehicleTree() {
      FetchVehicleTree()
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            this.vehicleTreeList = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //切换是否显示高级设置
    switchSetting() {
      this.advancedSettingShow = !this.advancedSettingShow;
      if (this.advancedSettingShow) {
        this.switchSettingBtnText = "收起高级设置";
      } else {
        this.switchSettingBtnText = "打开高级设置";
      }
    },
    //切换是否启用
    isApplyChange(value) {
      if (value === 1) {
        this.disabledByApply = false;
      } else {
        this.disabledByApply = true;
      }
    },
    /**
     * 保存超速报警设置
     */
    addData() {
      if (this.alarmSetId == 0) {
        //新增
        this.dataInfo.vehicleIdList = this.getVehicleIdListParam();
        this.FetchSaveLootAlarmSet(this.dataInfo);
      } else {
        //修改
        this.FetchUpdateLootAlarmSet(this.dataInfo);
      }
    },
    //新增
    FetchSaveLootAlarmSet(data) {
      this.loadingState = true;
      FetchSaveLootAlarmSet(data)
        .then(response => {
          this.submitCallback(response);
        })
        .catch(error => {
          console.log(error);
          this.loadingState = false;
        });
    },
    //修改
    FetchUpdateLootAlarmSet(data) {
      this.loadingState = true;
      FetchUpdateLootAlarmSet(data)
        .then(response => {
          this.submitCallback(response);
        })
        .catch(error => {
          console.log(error);
          this.loadingState = false;
        });
    },
    // 新增、修改完成时的回调函数
    submitCallback(data) {
      let type = data.code === 1 ? "success" : "error";
      let message = data.message;
      this.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 1000,
        onClose: () => {
          if (type === "success") {
            this.$router.push("/alarmSetCommonAlarmSetList");
          }
          this.loadingState = false;
        }
      });
    },
    //根据ID获取设置信息
    FetchFindLootAlarmById(data) {
      FetchFindLootAlarmById(data)
        .then(response => {
          if (response.result) {
            this.dataInfo = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 取消
    cancelSubmit() {
      this.$router.push("/alarmSetCommonAlarmSetList");
    },
    //获取选中车辆id
    getVehicleIdListParam() {
      let selected = this.$refs.e6select.getSelectValues();
      selected = selected.map(item => {
        return item.id;
      });
      return selected;
    }
  },
  computed: {
    radioLabel0() {
      return 0;
    },
    radioLabel1() {
      return 1;
    },
    radioLabel2() {
      return 2;
    }
  },
  mounted() {
    //初始化车辆树
    this.initVehicleTree();
    if (this.alarmSetId != 0) {
      //根据ID查询报警信息
      this.FetchFindLootAlarmById({ alarmSetId: this.alarmSetId });
    }
  }
};
</script>

<style scoped></style>
